import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessage(error: HttpErrorResponse | string): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error.error) {
    const { error: errorObj } = error;
    if (errorObj.description) {
      return error.error.description;
    }

    if (errorObj.detail) {
      return error.error.detail;
    }

    if (errorObj.title) {
      return error.error.title;
    }

    if (errorObj.message) {
      return error.error.message;
    }
  }

  if (error.status) {
    return `Request failed with ${error.status} ${error.statusText}`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'errors.somethingWentWrong';
}
